import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';

const wisdomRobotKF: AppRouteModule = {
  path: '/wisdomRobot',
  name: 'wisdomRobotKF',
  component: LAYOUT,
  meta: {
    orderNo: -75,
    icon: 'ant-design:android-outlined',
    title: '客服机器人',
  },
  children: [
    {
      path: 'kf',
      name: 'Kf',
      meta: {
        title: '客服知识库',
        icon: 'ant-design:aliwangwang-outlined'
      },
      children: [
        {
          path: 'problem',
          name: 'Problem',
          component: () => import('/@/views/knowledge/robot/Problem.vue'),
          meta: {
            // affix: true,
            title: '问题库',
            icon: 'ant-design:read-outlined'
          },
        }
      ]
    },
    {
      path: '/settings',
      name: 'settings',
      meta: {
        icon: 'ant-design:profile-outlined',
        title: '设置',
      },
      children: [
        {
          path: 'baseSettings',
          name: 'BaseSettings',
          component: () => import('/@/views/settings/baseSettings/BaseSettings.vue'),
          meta: {
            // affix: true,
            title: '基础设置',
            icon: 'ant-design:form-outlined'
          },
        },
        {
          path: 'artificial',
          name: 'Artificial',
          component: () => import('/@/views/settings/artificial/Artificial.vue'),
          meta: {
            // affix: true,
            title: '转人工规则',
            icon: 'ant-design:aliwangwang-outlined'
          },
        },
        {
          path: 'visitorSettings',
          name: 'VisitorSettings',
          component: () => import('/@/views/settings/visitorSettings/VisitorSettings.vue'),
          meta: {
            // affix: true,
            title: '访客端设置',
            icon: 'ant-design:user-switch-outlined'
          },
        },
      ],
    },
  ],
};

export default wisdomRobotKF;
